// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import axios from "axios"
import App from "./App.vue"
import configs from "@/config"
// require("./mock")
Vue.use(ElementUI, { size: "small" })
import router from "./router"
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Vuex from "vuex"
import { parseTime, resetForm } from "@/utils/index.js";


Vue.use(Vuex)
Vue.use(Viewer)
import store from "./store"

// import 'babel-polyfill';
axios.defaults.baseURL = configs.baseUrl
Vue.config.productionTip = false
axios.defaults.withCredentials = true

Vue.filter("changePrice", function(v) {
  let n = parseFloat(v / 100).toFixed(2)
  return n
})
Viewer.setDefaults({
  Options: {
    'inline': true, //启用lnline模式
    'button': true, //显示右上角关闭按钮
    'navbar': true, //显示缩略图导航
    'title': true, //显示当前图片的标题
    'toolbar': true, //显示工具栏
    'tooltip': true, //显示缩放百分比
    'movable': true, //显示可移动
    'zoomable': true, //图片是否可缩放
    'rotatable': true, //图片是否可旋转
    'scalable': true, //图片是否可翻转
    'transition': true, //使用css3过度
    'fullscreen': true, //播放时是否全屏
    'keyboard': true, //是否支持键盘
    'url': 'data-source' //设置大图片的url
  }
})
axios.interceptors.request.use(
  function(config) {
    // 在发送请求之前做些什么
    const token = sessionStorage.token
    config.headers.common.token = token
    return config
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  function(res) {
    if (res.data.errorCode == 405) {
      sessionStorage.clear()
      router.push("/login")
    }
    return res
  },
  function(err) {
    return Promise.reject(err)
  }
)
// 全局方法挂载
Vue.prototype.resetForm = resetForm;
Vue.prototype.parseTime = parseTime;
Vue.prototype.$axios = axios

router.beforeEach((to, from, next) => {
  let isLogin = sessionStorage.isLogin
  if (!to.meta.isNeedLogin) {
    next()
    return
  }
  if (isLogin) {
    next()
    return
  }
  if (to.path == "/login") {
    next()
    return
  }
  next("/login")
})

Vue.directive('enterNextInput', {
  inserted: function (el) {
    el.addEventListener("keypress",function(e){
      e = e || window.event;
      let charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;
      if(charcode == 13){
        var dom = document.getElementsByTagName("input")
        console.log(dom)
        for (var i = 0; i < dom.length; i++) {
          if (dom[i] == document.activeElement) {
            if (i == dom.length) {
              return
            }
            if (dom[i + 1].disabled) {
              dom[i + 2].focus()
            } else {
              dom[i + 1].focus()
            }
            return
          }
        }
      }
    });
  }
});
Vue.prototype.jquery = function (id) {
  return document.getElementById(id);
};
Vue.prototype.$EventBus = new Vue()
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
})



// WEBPACK FOOTER //
// ./src/main.js